{
  "labels": {
    "trenutni": "Current signature:",
    "alt": "You have not added a signature yet!",
    "buttons": {
      "dodaj": "Add / Replace your signature",
      "shrani": "Save",
      "pocisti": "Clear"
    }
  }
}